export const FILE_NAME_MAX_LENGTH = 40
export const MODAL_BUFFER_WIDTH = 400
export const MODAL_MARGIN_HEIGHT = 80
export const MODAL_MARGIN_WIDTH = 200
export const MODAL_MIN_HEIGHT = 600
export const MODAL_MIN_WIDTH = 768
export const HEADER_FILENAME_MAX_LENGTH = 60

export const QUANTITY_RANGE_UNAVAILABLE = 'QUANTITY_RANGE_UNAVAILABLE'
export const ASSEMBLY_PROCESS_TYPE = 'Assembly'
export const INSPECTION_PROCESS_TYPE = 'Inspection'
export const CERTIFICATION_PROCESS_TYPE = 'Certification'
export const FINISHING_PROCESS_TYPE = 'Finishing'
export const FINISHING_POST_PROCESS_TYPE = 'finishing'
export const NON_FINISHING_POST_PROCESS_TYPE = 'non-finishing'
export const THREADS_KEY = 'threads'
export const THREADS_TAB = 'Threads'
export const DRAWING_ANALYSIS_KEY = 'drawing-analysis'
export const DRAWING_ANALYSIS = 'Drawing analysis'
export const CONFIGURATION_KEY = 'configuration'
export const ADDITIONAL_REQ_KEY = 'additional-requirements'
export const DFM_FEEDBACK_KEY = 'feedback'
export const PART_DFM_REPORT_KEY = 'part-dfm-report'
export const PART_DFM_REPORT = 'part-dfm-report-feedback'
export const VIEWER_2D = 'drawing'
export const CONFIGURATION = 'Configuration'
export const ADDITIONAL_REQUIREMENT = 'Additional requirements'
export const DFM_FEEDBACK = 'Manufacturability feedback'
export const PLACEMENT = 'configuration-modal'
export const PART_VIEWER_PLACEMENT = 'partviewer-modal'
export const TAPS_SIDEBAR_PLACEMENT = 'TAPS_SIDEBAR_PLACEMENT'
export const REVISION_CONFIGURATION_PLACEMENT =
    'revision-viewer-configuration-modal'
export const AUTO_GENERATING_DRAWING_MESSAGE = [
    'Creating top, front, and right views…',
    'Creating isometric view…',
    'Adding dimensions and hole callouts…',
]
export const CYCLE_LOADING_MESSAGE_INTERVAL = 5000
export const BACK_URL_OBJECT_FOR = {
    ADMIN_SEARCH: 'adminSearch',
    ADMIN_PANEL: 'adminPanel',
    USER: 'user',
}
export const PREVIEW_TYPES = {
    drawing: 'drawing',
    model: 'model',
}
export const PRODUCTION_DAYS_TOOLTIP_PART_I =
    'Part production lead-time starts after T samples are approved.'
export const PRODUCTION_DAYS_TOOLTIP_PART_II = 'Days are production days only.'

export const DRAWING_REVIEW_HELP_CENTER_URL =
    'https://help.fictiv.com/en/articles/5714756'

export const QUANTITY_RANGE_UNAVAILABLE_MSG = `Pricing not available at this quantity. Please
    adjust the quantity or chat with us for more
    information.`
